"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DragHandlerIcon = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement("svg", { width: "9", height: "14", viewBox: "0 0 9 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className || "drag-handler" },
        react_1.default.createElement("ellipse", { cx: "2.4729", cy: "2.07843", rx: "1.49573", ry: "1.47059", fill: "#A8A8A8" }),
        react_1.default.createElement("ellipse", { cx: "7.48584", cy: "2.07843", rx: "1.49573", ry: "1.47059", fill: "#A8A8A8" }),
        react_1.default.createElement("ellipse", { cx: "2.4729", cy: "6.98039", rx: "1.49573", ry: "1.47059", fill: "#A8A8A8" }),
        react_1.default.createElement("ellipse", { cx: "7.48584", cy: "6.98039", rx: "1.49573", ry: "1.47059", fill: "#A8A8A8" }),
        react_1.default.createElement("ellipse", { cx: "2.4729", cy: "11.8824", rx: "1.49573", ry: "1.47059", fill: "#A8A8A8" }),
        react_1.default.createElement("ellipse", { cx: "7.48584", cy: "11.8824", rx: "1.49573", ry: "1.47059", fill: "#A8A8A8" })));
};
exports.default = DragHandlerIcon;
//# sourceMappingURL=DragHandler.js.map